module.exports = __webpack_public_path__ + "static/img/10.ec6c7b1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/dglfr/10.png
// module id = YXnM
// module chunks = 0